export default "__VITE_ASSET__D_$XwFY9__"